const config = {
  host:"http://www.qiniangniang.com",
  openHost: "http://www.qiniangniang.com/#",
  api: "/api",
  upload:"/api/upload"
};

export default config;